import { useEffect } from 'react';
import { useAuth } from '../../../components/contexts/AuthContext';
import { useSocket } from '../../../components/contexts/SocketContext';
import { getBusinessResolution, isOperationId, validResolution } from '../models/businessResolutionApi';
import { applyVerifiedResolution, savedResolutionFences } from '../models/businessResolutionFences';
import { pendingResolutionIds, clearResolutionRequest } from '../models/businessResolutionRequest';
export default function BusinessResolutionRecovery() {
  const { authState } = useAuth(); const { socket } = useSocket();
  useEffect(() => {
    const actor = authState?.id;
    if (!authState?.isAuthenticated || !actor) return undefined;
    let active = true; const pending = new Set(), again = new Set();
    const reconcile = () => {
      const ids = new Set([...savedResolutionFences(actor).map(item => item.operationId).filter(isOperationId), ...pendingResolutionIds(actor)]);
      ids.forEach(id => {
        if (pending.has(id)) { again.add(id); return; }
        pending.add(id);
        getBusinessResolution(id).then(row => { if (active && row.operation_id === id) { applyVerifiedResolution(actor, row); if (validResolution(row)) clearResolutionRequest(actor, id); } }).catch(() => {}).finally(() => { pending.delete(id); if (active && again.delete(id)) reconcile(); });
      });
    };
    reconcile(); socket?.on('connect', reconcile); socket?.on('messaging.business_send.resolved', reconcile);
    window.addEventListener('business-send-updated', reconcile); window.addEventListener('storage', reconcile);
    return () => { active = false; socket?.off('connect', reconcile); socket?.off('messaging.business_send.resolved', reconcile); window.removeEventListener('business-send-updated', reconcile); window.removeEventListener('storage', reconcile); };
  }, [authState?.id, authState?.isAuthenticated, socket]);
  return null;
}
